import { ReactElement, useCallback } from 'react';
import { Trans } from 'react-i18next';

import { Translate, useBoolean } from '@dreryk/react-common';
import {
   Link,
   Modal,
   ModalCancelButton,
   ModalCloseButton,
   ModalWidth,
   RemoveIcon,
   StrongText,
   StyledFlex,
} from '@dreryk/react-components';

import { medicalServicesMappingsTranslationKeys } from '../../../translations';

import { DocplannerServiceMappingRemoveButton } from './DocplannerServiceMappingRemoveButton';

type DocplannerServiceMappingRemoveProps = {
   readonly mappingId: number;
   readonly docplannerServiceName: string;
   readonly receptionServiceName: string;
   readonly onMappingRemoveSuccess: VoidFunction;
};

const ServiceName = (props: { readonly serviceName: string }): ReactElement => {
   return <StrongText testId={'docplannerServiceName'}>{props.serviceName}</StrongText>;
};

export const DocplannerServiceMappingRemove = (props: DocplannerServiceMappingRemoveProps): ReactElement => {
   const [{ setTrue: openMappingRemoveModal, setFalse: closeMappingRemoveModal }, modalOpened] = useBoolean();

   const handleRemoveSuccess = useCallback(() => {
      closeMappingRemoveModal();
      props.onMappingRemoveSuccess();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [closeMappingRemoveModal, props.onMappingRemoveSuccess]);

   return (
      <>
         <Link testId={'medicalServiceRemove'} icon={<RemoveIcon />} onClick={openMappingRemoveModal} />
         {modalOpened ? (
            <Modal
               testId={'medicalServiceRemove'}
               title={medicalServicesMappingsTranslationKeys.removingMapping}
               width={ModalWidth.NORMAL}
            >
               <StyledFlex direction={'column'} gap={'24px'}>
                  <Translate>{medicalServicesMappingsTranslationKeys.areYouSureRemoveMapping}</Translate>
                  <StyledFlex direction={'column'} gap={'12px'}>
                     <div>
                        <Trans
                           i18nKey={medicalServicesMappingsTranslationKeys.docplannerServiceWithName}
                           components={{
                              docplannerServiceName: <ServiceName serviceName={props.docplannerServiceName} />,
                           }}
                        />
                     </div>
                     <div>
                        <Trans
                           i18nKey={medicalServicesMappingsTranslationKeys.receptionServiceWithName}
                           components={{
                              receptionServiceName: <ServiceName serviceName={props.receptionServiceName} />,
                           }}
                        />
                     </div>
                  </StyledFlex>
               </StyledFlex>
               <DocplannerServiceMappingRemoveButton mappingId={props.mappingId} onSuccess={handleRemoveSuccess} />
               <ModalCancelButton onClick={closeMappingRemoveModal} />
               <ModalCloseButton onClick={closeMappingRemoveModal} />
            </Modal>
         ) : null}
      </>
   );
};
